import { Fragment, useCallback, useState } from 'react';
import { LogOut, Menu, Settings, X } from 'lucide-react';

import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { SidebarNav } from './nav/sidebar-nav';

import { useAuth } from '../../../context/AuthContext';

import { Logo } from '../../../shared/ui/logo';

import styles from './sidebar-menu.module.css';

export const SidebarMenu = () => {
	const intl = useIntl();
	const location = useLocation();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [sidebarOpen] = useState(true);
	const [isMobile] = useState(
		typeof window !== 'undefined' && window.innerWidth <= 900,
	);
	const { onLogout } = useAuth();
	const [submitting, setSubmitting] = useState(false);

	const handleLogOut = useCallback(async () => {
		setSubmitting(true);
		try {
			await onLogout();
			setSubmitting(false);
		} catch {
			setSubmitting(false);
		}
	}, [onLogout]);

	return (
		<Fragment>
			<div
				className={`${styles.mobileBackdrop} ${
					mobileMenuOpen ? styles.mobileBackdropActive : ''
				}`}
				onClick={() => setMobileMenuOpen(false)}
			/>

			{!mobileMenuOpen && (
				<button
					className={styles.mobileMenuBtn}
					onClick={() => setMobileMenuOpen(true)}
					aria-label='Open menu'
					style={isMobile ? { top: 14 } : undefined}
				>
					<Menu size={24} stroke='white' />
				</button>
			)}

			<aside
				className={`${styles.sidebar} ${
					sidebarOpen ? styles.sidebarOpen : styles.sidebarClosed
				} ${mobileMenuOpen ? styles.mobileMenuOpen : ''}`}
			>
				<div className={styles.sidebarHeader}>
					<Logo to='/overview' />
					<button
						className={styles.sidebarCloseBtn}
						onClick={() => setMobileMenuOpen(false)}
						aria-label='Close menu'
					>
						<X size={24} stroke='black' />
					</button>
				</div>

				<SidebarNav />

				<div className={styles.sidebarFooter}>
					<Link
						to='/settings'
						className={`${styles.navItem} ${
							location.pathname === '/settings' ? styles.navItemActive : ''
						}`}
					>
						<Settings size={20} />
						<span className={styles.navList}>
							{intl.formatMessage({ id: 'NavBarAuthId13' })}
						</span>
					</Link>

					<button
						className={styles.navItem}
						disabled={submitting}
						onClick={handleLogOut}
					>
						<LogOut size={20} />
						<span>{intl.formatMessage({ id: 'NavBarAuthId9' })}</span>
					</button>
				</div>
			</aside>
		</Fragment>
	);
};
